import React, { useEffect, useState } from 'react';
import './navbar.scss';
import { Link, useLocation } from 'react-router-dom';
import HeaderCategory from '../category/HeaderCategory';
import { axiosAuth } from '../../api/api';
import { ICategoryNews, INews } from '../../tpyes/comment';

const Navbar = () => {
  const [responsive, setResponsive] = useState('');
  const [showTopic, setShowTopic] = useState(false);
  const [categories, setCategories] = useState([]);
  const { pathname } = useLocation();

  function handleShowTopic() {
    setShowTopic(!showTopic);
  }

  const handleResize = () => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
  };

  useEffect(() => {
    getCategories();
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const getCategories = async () => {
    const response = await axiosAuth?.get('/news/api/news-category/');
    const dataList = await response.data;
    //dataList에서 category object만 뽑아서 setCategories에 저장
    const newCategories = dataList.map((item: INews) => item?.latest_news?.category);
    newCategories.unshift({ id: 100, name: 'ALL', order: 0, main_image: '' });
    setCategories(newCategories);
  };

  return (
    <>
      <div className="navbar">
        <div className="navbox">
          <div className="iconBox">
            <img
              src="/seamansclub-news/assets/images/seamansicon-black.png"
              alt=""
              className="logo"
              onClick={() => {
                window.open('https://www.seamansclub.com/', '_blank');
              }}
            />
            <Link to="/">
              <img src="/seamansclub-news/assets/svg/logo.svg" alt="" className="icon" id="icon" />
            </Link>
          </div>

          <div className="tabBox">
            <ul className="tab">
              <li>
                <Link to="/" className={`tab-item ${pathname === '/' && !showTopic ? 'link-check' : ''}`}>
                  HOME
                </Link>
              </li>
              <li className={`tab-item ${pathname.startsWith('/newsTopic') || showTopic ? 'link-check' : ''}`} onClick={handleShowTopic}>
                <div>TOPICS</div>
              </li>
            </ul>
            {showTopic && responsive === 'desktop' && (
              <div className="showTopic">
                {categories.length > 0 &&
                  categories.map((category: ICategoryNews) => {
                    return <HeaderCategory pageId={category.id} value={category.name} setShowTopic={setShowTopic} />;
                  })}
              </div>
            )}
          </div>
        </div>
      </div>
      {showTopic && responsive !== 'desktop' && (
        <div className="showTopic-mobile-box">
          <div className="showTopic-mobile">
            {categories.length > 0 &&
              categories.map((category: ICategoryNews) => {
                return <HeaderCategory key={category.id} pageId={category.id} value={category.name} setShowTopic={setShowTopic} />;
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
